import axios from 'axios';

const RESOURCE_NAME = '/api/file';

const UP_CONFIG = {
    headers: {
        "Content-Type": "multipart/form-data"
    }
};

const STREAM_CONFIG = {
    responseType: 'arraybuffer'
};

const DOWN_CONFIG = {
    responseType: 'blob'
};


export default {

    get(guid) {
        return axios.get(`${RESOURCE_NAME}/${guid}`, DOWN_CONFIG);
    },

    getStream(guid) {
        return axios.get(`${RESOURCE_NAME}/${guid}`, STREAM_CONFIG);
    },

    upload(id, data) {
        return axios.post(`${RESOURCE_NAME}/${id}`, data, UP_CONFIG);
	},
	
    delete(folder, guid) {
        return axios.delete(`${RESOURCE_NAME}/${folder}/${guid}`);
    },


};


// WEBPACK FOOTER //
// ./src/api-services/file.service.js